export default __webpack_public_path__ + "static/media/manchor.bc71c83f.svg";